exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lista-horizontal {\r\n    display: inline-block;\r\n    flex-wrap: wrap;\r\n    list-style-type: none;\r\n}\r\n\r\n.item-aplicacion .item-titulo {\r\n    color: #000000; /* Cambiado a azul oscuro */\r\n}\r\n\r\n.item-icono-app {\r\n    color: #004d9b; /* Azul oscuro para mantener consistencia */\r\n    padding-right: 8px;\r\n}\r\n\r\na {\r\n    color: #000000; /* Azul oscuro para los enlaces */\r\n    text-decoration: none;\r\n}\r\n\r\na:hover {\r\n    color: #000000; /* Azul más oscuro en hover */\r\n}\r\n\r\n.item-apl-titulo {\r\n    color: #000000; /* Azul oscuro */\r\n}\r\n\r\n.item-apl-titulo:hover {\r\n    transition: color 0.3s ease;\r\n    color: #002e66; /* Azul más oscuro al hacer hover */\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/contenedor-aplicaciones/item-aplicacion/item-aplicacion.style.css
// module id = 633
// module chunks = 0